import { Button, Flex, Text } from '@radix-ui/themes'

import { AnnouncementBody, useJourney } from '../../journey'

import { chileautosHighlightsSpec } from './journey'
import { Simulator } from './Simulator'
import { Headline, Kicker, Note, StepList } from './Story'

import type { AnnouncementProps } from '../types'

export const Body = ({ active, onDismiss }: AnnouncementProps) => {
  const journey = useJourney(chileautosHighlightsSpec, active)

  return (
    <AnnouncementBody
      heading="Primero el permiso, después el destacado"
      blurb="Un administrador le da el permiso a un vendedor. El vendedor vuelve a iniciar sesión, destaca un aviso con TopSpot y lo encuentra con el nuevo filtro."
      caption={journey.caption}
      stage={<Simulator state={journey} />}
      story={
        <>
          <Kicker />
          <Headline className="text-[15px]" />
          <p className="mb-3.5 mt-1 text-xs leading-relaxed text-[#706d71]">
            Aplica Premium, TopSpot, Showcase y TopNitro aviso por aviso, desde Publicaciones o desde la ficha del
            vehículo. Antes, un administrador tiene que dar el permiso.
          </p>

          <StepList active={journey.step} size="wide" />

          <div className="mt-3">
            <Note size="wide" />
          </div>

          <Flex justify="end" className="mt-auto pt-4">
            <Button size="2" color="red" onClick={onDismiss}>
              <Text weight="bold">Entendido</Text>
            </Button>
          </Flex>
        </>
      }
    />
  )
}
